// import {getFlowStatus} from "./user.service";
import Storage from "./storage.service";
import { emptyReject, emptyPromise } from "./helpers";
import {
	getDefaultProduct,
	getCurrentProductCommitment,
	selectProduct,
} from "./products.service";
import { next } from "./flow.service";
import HTTP from "./http.service";
import { setNumber } from "./number.service";
import Promotions from "./promotions.service";
import Settings from "./settings.service";
import { getFlowStatus } from "./user.service";
import { handleError } from "./errors.service";
import { t } from "./translation.service";
import { BB_SERVICE_TYPES, BB_PRODUCT_CODE } from "./constants.service";

import { processAvailablePlansAPI, processSavedPlan } from "./plans.middleman";

// const getPlanFromValues = (values_arr) => {
// 	let commitment = values_arr[0];
// 	let product = Products.getProductByCommitment(commitment);
// 	let values = {};
// 	for (let index in Settings.types) {
// 		let hindex = parseInt(index);
// 		let type = Settings.types[index];
// 		values[type] = values_arr[hindex + 1];
// 	}

// 	let ids = [];

// 	let product_group = Storage.get("PlansbyProductCode")[product.ProductCode];

// 	let vmo_subplans = product_group["vmo_subplans"];

// 	for (let subplan_id of Object.keys(vmo_subplans)) {
// 		let subplan = vmo_subplans[subplan_id];
// 		let subplan_type = subplan["Type"];
// 		let subplan_val = subplan["vmo_ValueFormatted"];
// 		let our_val = values[subplan_type];

// 		if (our_val === Settings.unlimited_text_short) {
// 			our_val = Settings.unlimited_text;
// 		}

// 		if ("" + subplan_val === "" + our_val) {
// 			ids.push(parseInt(subplan_id));
// 		}
// 	}

// 	return ids.sort();
// };

// @Todo
// const isVipPlan = (plan) => {
// 	return false;
// }

// const isValuePlan = (plan) => {
// 	if(plan && plan["vmo_subplans_ids_sorted"]){
// 		let lookup = plan["vmo_subplans_ids_sorted"].join(",");
// 		let default_product = Products.getDefaultProduct();
// 		let PlansbyProductCode = Storage.get("PlansbyProductCode");
// 		if(default_product && PlansbyProductCode){
// 			let group = PlansbyProductCode[default_product.ProductCode];
// 			if(group){
// 				let locked_plans_lookups = group["vmo_locked_plans"]["by_lookup"];
// 				locked_plans_lookups = [...new Set(locked_plans_lookups)];
// 				return (locked_plans_lookups.indexOf(lookup) !== -1);
// 			}
// 		}
// 	}
// 	return false;
// }

// @Todo
// const isPaygPlan = (plan) => {
// 	return false;
// }

// const checkParams = () => {
// 	let fromParams = false;
// 	let params_combo = false;
// 	let saved_plan = Storage.get("saved_plan");

// 	let saved_plan_combo = null;

// 	if (saved_plan) {
// 		saved_plan_combo = getCustomCombo(saved_plan);
// 		params_combo = saved_plan_combo;
// 	} else {
// 		if (Storage.get("preset")) {
// 			params_combo = Storage.get("preset");
// 		} else {
// 			if (Storage.get("custom_combo", true)) {
// 				params_combo = Storage.get("custom_combo", true);
// 			}
// 		}
// 	}

// 	if (params_combo) {
// 		let params_values = params_combo.split("-");

// 		if (params_values.length === 4) {
// 			let commitment = params_values[0];

// 			let plan_ids = getPlanFromValues(params_values);

// 			fromParams = {
// 				commitment: commitment,
// 				ids: plan_ids,
// 			};
// 		}
// 	}

// 	return fromParams;
// };

// const selectInitialPlan = () => {
// 	let business = Storage.get("businessConfig");

// 	let default_selected_plan = business["default_selected_plan"];

// 	let fromParams = checkParams();

// 	if (fromParams) {
// 		let product = Products.getProductByCommitment(fromParams.commitment);

// 		if (product && fromParams.ids) {
// 			Products.selectProduct(product, "333");
// 			if (fromParams.ids.length === Settings.types.length) {
// 				default_selected_plan = fromParams.ids;
// 			}
// 		}
// 	}

// 	// @temp AB test
// 	if(!Storage.get("saved_plan") && !Storage.get("preset")){
// 		if(window.default_product){
// 			Products.selectProductByDuration(window.default_product, 'AB');
// 		}
// 	}

// 	let plan = getPackageFromIDs(default_selected_plan);
// 	if(isValuePlan(plan)){
// 		plan = getPackageFromIDs(business["default_selected_plan"]);
// 	}

// 	// if (!planFromIDExists(default_selected_plan)) {
// 	//   default_selected_plan = getFoolProofCustomPlan();
// 	// }

// 	selectCustomPlan(plan);

// };

// const checkInternationalMinutes = (proceedAction) => {
// 	let plan = Storage.get("selectedCustomPlan");
// 	let minutes = 0;
// 	if (plan && plan["vmo_subplans_ids_by_type"]) {
// 		let int_id = plan["vmo_subplans_ids_by_type"]["VOICE-INT"];
// 		let int_plan = plan["vmo_subplans"][int_id];
// 		minutes = int_plan["vmo_ValueFormatted"];
// 	}

// 	if (minutes > 0) {
// 		toggleInternationalModal(true);
// 	} else {
// 		toggleInternationalModal(false);
// 		proceedAction();
// 	}
// };

// const toggleInternationalModal = (val = "") => {
// 	if (val === "") {
// 		val = !Storage.get("showInternationalModal");
// 	}
// 	Storage.set("showInternationalModal", val);
// };

const getPackageFromIDs = (combination_array) => {
	if (typeof combination_array === "string") {
		combination_array = combination_array.split(",");
	}

	combination_array = combination_array.sort();

	let default_product = getDefaultProduct();

	let PlansbyProductCode = Storage.get("PlansbyProductCode");

	let product_plans = PlansbyProductCode[default_product.ProductCode];

	let plan_to_select =
		product_plans["vmo_packages"][combination_array.join(",")];

	return plan_to_select;
};

const setReservationTypes = (type) => {
	let config = {
		method: "get",
		url: "/numbers/reservation?reservation_types=" + type,
	};
	return HTTP(config);
};

const httpSavePlan = () => {
	let selectedPlan = Storage.get("selectedCustomPlan");	

	let data = {
		plan_ids: selectedPlan["vmo_subplans_ids_sorted"].join(","),
		product_code: selectedPlan.ProductCode,
	};
	if (Storage.get("selected_recharge")) {
		data["recharge_amount"] = Storage.get("selected_recharge");
	}

	Storage.clear("selected_recharge");

	let config = {
		method: "post",
		url: "/plans/saved_plans",
		data: data,
	};
	return HTTP(config);
};

// const saveCustomPlan = () => {
// 	httpSavePlan()
// 		.then((response) => {
// 			let product = Products.getCurrentProduct();
// 			Products.saveProduct(product).then((res) => {
// 				getFlowStatus(13)
// 					.then((res) => {
// 						Flow.next();
// 						setTimeout(() => {
// 							getSavedPlans()
// 								.then((res) => {})
// 								.catch((error) => {});
// 						}, 500);
// 					})
// 					.catch((error) => {});
// 			});
// 		})
// 		.catch((error) => {
// 			// handleError(error, "51");
// 		});
// };

const selectCustomPlan = (selectedPlan, lock_trigger_type = false) => {
	Storage.clear("preset");
	Storage.set("selectedCustomPlan", selectedPlan);
	let custom_combo = getCustomCombo(selectedPlan);
	Storage.set("custom_combo", custom_combo, true);
};

const selectAndSavePlan = (selectedPlan) => {
  selectCustomPlan(selectedPlan);
		if(selectedPlan.ProductCode === "194"){
				Storage.set('isYearlyPlanSelected', true)
		} else{
				Storage.clear('isYearlyPlanSelected')
		}
		console.log("selectedPlan", selectedPlan)
	let currentRoute;	
	if(selectedPlan?.ProductCode !== 194 && !selectedPlan?.PackageEligibility.includes("DataSimOnly")) currentRoute = 'coverage_details'
	httpSavePlan()
		.then((response) => {
			getFlowStatus(1233)
				.then((res) => {
					getSavedPlans()
						.then((res) => {
							Storage.clear("modem_latlng");

							if(Storage.get("loading_text") === t("LOADING_TEXT_SAVE_PLAN")) {
								Storage.clear("loading_text");
							}
							next(currentRoute);
							
						})
						.catch((error) => {});
				})
				.catch((error) => {});
		})
		.catch((error) => {
			handleError(error, "selectAndSavePlan");
		});
};

const getCustomCombo = (plan) => {
	let values = [];

	for (let type of Settings.types) {
		let subplan_id = plan["vmo_subplans_ids_by_type"][type];

		let subplan = plan["vmo_subplans"][subplan_id];
		let val = null;
		if (subplan) {
			val = subplan["vmo_ValueFormatted"];
		}
		if (val && val === Settings.unlimited_text) {
			val = Settings.unlimited_text_short;
		}
		values.push(val);
	}

	let dashed_plan = values.join("-");
	let commitment = plan.product
		? plan.product.CommitmentDuration
		: getCurrentProductCommitment();
	let custom_combo = commitment + "-" + dashed_plan;
	return custom_combo;
};

const getPlansByProductCodes = (codes = []) => {
	if (codes.length === 0) {
		let products = Storage.get("products") || [];

		for (let product of products) {
			codes.push(product.ProductCode);
		}
	}

	let fetcher = fetchAvailablePlansByProductCode;

	fetcher(codes.join(","))
		.then((resp) => {
			let PlansbyProductCode = processAvailablePlansAPI(resp.data);

			Storage.setShared("PlansbyProductCode", PlansbyProductCode);
		})
		.catch((error) => {});
};

const getSavedPlan = () => {
	let flags = Storage.get("flow_status_flags");
	if (flags && flags.is_plan_selected && !Storage.get("saved_plan")) {
		return getSavedPlans();
	} else {
		return emptyPromise();
	}
};

const getSavedPlans = () => {
	if (Storage.get("fetching_saved_plans")) {
		return emptyReject();
	}

	let flags = Storage.get("flow_status_flags");
	if (!flags || !flags.is_plan_selected) {
		return emptyReject();
	}

	Storage.set("fetching_saved_plans", true);

	let f = fetchSavedPlans();

	f
		.then((response) => {
			let saved_product = response.data.product;

			selectProduct(saved_product, "saved_product");

			let plan =
				response.data.save_plans && response.data.save_plans[0]
					? response.data.save_plans[0]
					: null;
			if (plan) {
				plan.product = saved_product;

				let saved_plan = processSavedPlan(plan);

				let promotions = Promotions.getPromotionsByPlan(saved_plan);

				Storage.set("promotions", promotions);

				Storage.set("saved_plan", saved_plan);

				// Events.when_plan_is_selected(saved_plan);

				setReservationTypes("1,3").then((response) => {
					if (
						response.data &&
						response.data.numbers &&
						response.data.numbers[0] &&
						response.data.numbers[0].MSISDN
					) {
						setNumber(response.data.numbers[0]);
					}
				});
			} else {
				Storage.clear("saved_plan");
				Storage.clear("selectedPlanSpecsIDs");
			}
		})
		.catch((error) => {})
		.finally(() => {
			Storage.clear("fetching_saved_plans");
		});

	return f;
};

const fetchAvailablePlansByProductCode = (code) => {
	if (Storage.get("fetchedAvailablePlansByProductCode")) {
		let data = Storage.get("fetchedAvailablePlansByProductCode");
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		if (Storage.get("fetching_available_plans_" + code)) {
			return emptyReject();
		}

		Storage.set("fetching_available_plans_" + code, true);
		let config = {
			method: "get",
			url:
				"/products/available_plans?product_codes=" +
				code +
				"&service_types=" +
				BB_SERVICE_TYPES,
		};
		let f = HTTP(config);
		f.finally(() => {
			Storage.clear("fetching_available_plans_" + code);
		});
		return f;
	}
};

const fetchSavedPlans = () => {
	let config = {
		method: "get",
		url: "/plans/saved_plans",
	};
	return HTTP(config);
};


const isInt = (n) => {
	return Number(n) === n && n % 1 === 0;
}

const format_number = (n) => {
	let result =  isInt(n)? n : (Math.round((n + Number.EPSILON) *100)/100).toFixed(2);
	// remove extra decimal zeros , example: 299.00  
	return isInt(+result)? parseInt(result): result;
}

const vat_percentage = () => {
	let vat = Storage.get("businessConfig").vat_percentage;
	return vat ? vat/100 : 0.05;
}

const exclude_vat = (vat_total) => {
	let res = vat_total / (1+vat_percentage());
	return format_number(res);
}

const add_vat = (vat_total) => {
	let res = vat_total * (1+vat_percentage());
	return format_number(res);
}
function getPlanByLookup(lookupValue) {
	let plans;
	if (!Storage.get("available_plans")) {
		plans = getPlansByProductCodes([BB_PRODUCT_CODE]);
}else {
	plans = Storage.get("available_plans");
}
for (const plan of plans) {
					if (plan.lookup === lookupValue) {
									return plan;
					}
	}
	return null;
}
export {
	getSavedPlan,
	getPlansByProductCodes,
	getPackageFromIDs,
	selectAndSavePlan,
	getSavedPlans,
	exclude_vat,
	add_vat,
	format_number,
	fetchAvailablePlansByProductCode,
	getPlanByLookup
};
